
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 .4A8.6 8.6 0 1017.6 9 8.61 8.61 0 009 .4zm-.41 4.21a10.41 10.41 0 01-2.09-.28A9.33 9.33 0 018.59 1.6zm0 .77v3.15H5.41A10.73 10.73 0 016.17 5a11.39 11.39 0 002.42.38zm0 3.92v3.14a12 12 0 00-2.48.35 10.43 10.43 0 01-.7-3.49zm0 3.91v3.19a9.39 9.39 0 01-2.17-2.89 11.12 11.12 0 012.17-.3zm.76 0a10.7 10.7 0 012.2.31 9.41 9.41 0 01-2.2 2.91zm0-.77V9.3h3.21a10.49 10.49 0 01-.7 3.5 11.6 11.6 0 00-2.51-.36zm0-3.91V5.38A11.48 11.48 0 0011.79 5a10.38 10.38 0 01.77 3.49zm0-3.92v-3a9.06 9.06 0 012.11 2.75 10.42 10.42 0 01-2.11.25zm.8-3.35a7.91 7.91 0 014.11 1.94 10.12 10.12 0 01-2 .92 10.22 10.22 0 00-2.11-2.86zm-4.4 2.86a9.44 9.44 0 01-2-.9 7.83 7.83 0 014.1-2 10.12 10.12 0 00-2.1 2.9zm-.32.71a11.16 11.16 0 00-.78 3.7H1.19a7.78 7.78 0 012-4.74 11 11 0 002.24 1.04zM4.64 9.3a11.23 11.23 0 00.73 3.7 10.77 10.77 0 00-2.3 1.09A7.79 7.79 0 011.18 9.3zm1 4.42a10.11 10.11 0 002.14 3 7.81 7.81 0 01-4.21-2.07 9.71 9.71 0 012.11-.93zm6.61 0a9.82 9.82 0 012.08 1 7.85 7.85 0 01-4.22 2 10.06 10.06 0 002.18-2.99zm.3-.71a11.1 11.1 0 00.74-3.72h3.49a7.79 7.79 0 01-1.91 4.82A10.28 10.28 0 0012.59 13zm.74-4.49a11.24 11.24 0 00-.8-3.71 10.51 10.51 0 002.28-1.06 7.77 7.77 0 012 4.77z","fill":"var(--map-icons)"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/map_icons/satellite.svg